export const SET_CURRENT_USER = "user/SET_CURRENT_USER";
export const CHECK_USER_SESSION = "user/CHECK_USER_SESSION";
export const GOOGLE_SIGN_IN_START = "user/GOOGLE_SIGN_IN_START";
export const EMAIL_SIGN_IN_START = "user/EMAIL_SIGN_IN_START";
export const SIGN_IN_SUCCESS = "user/SIGN_IN_SUCCESS";
export const SIGN_IN_FAILED = "user/SIGN_IN_FAILED";
export const SIGN_UP_START = "user/SIGN_UP_START";
export const SIGN_UP_SUCCESS = "user/SIGN_UP_SUCCESS";
export const SIGN_UP_FAILED = "user/SIGN_UP_FAILED";
export const SIGN_OUT_START = "user/SIGN_OUT_START";
export const SIGN_OUT_SUCCESS = "user/SIGN_OUT_SUCCESS";
export const SIGN_OUT_FAILED = "user/SIGN_OUT_FAILED";
